interface CardItem {
  image: string;
  title: string;
  tag: string;
  tagType: '韩漫' | '日漫' | '国漫';
  desc: string;
  status: string;
}

const CARDS: CardItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20dungeon%20adventure%20scene%20with%20a%20lone%20warrior%20facing%20massive%20shadow%20monsters%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20dark%20tone%2C%20cinematic%20composition%2C%20clean%20simple%20background%2C%20manga%20cover%20art%20aesthetic&width=800&height=600&seq=card-manga-01&orientation=landscape',
    title: '我独自升级',
    tag: '韩漫',
    tagType: '韩漫',
    desc: '史上最弱猎人觉醒逆天系统，从E级一路飙升到S级，独自征服地下城的热血传奇。',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20supernatural%20battle%20scene%20with%20dynamic%20energy%20effects%2C%20two%20powerful%20sorcerers%20clashing%2C%20dark%20urban%20fantasy%20atmosphere%2C%20bold%20line%20art%2C%20professional%20manga%20cover%20illustration%2C%20clean%20simple%20background&width=800&height=600&seq=card-manga-02&orientation=landscape',
    title: '咒术回战',
    tag: '日漫',
    tagType: '日漫',
    desc: '高中生吞下宿傩手指后卷入咒术师与诅咒的残酷战争，热血战斗与深刻友情的完美融合。',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20martial%20arts%20fantasy%20scene%20with%20ancient%20Chinese%20architecture%2C%20a%20young%20hero%20with%20flowing%20robes%20and%20supernatural%20powers%2C%20traditional%20ink%20painting%20aesthetic%20blended%20with%20modern%20manhua%20style%2C%20warm%20earth%20tones&width=800&height=600&seq=card-manga-03&orientation=landscape',
    title: '一人之下',
    tag: '国漫',
    tagType: '国漫',
    desc: '普通大学生意外卷入异人世界的惊天秘密，道术、异能、江湖纷争，国漫巅峰之作。',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20drama%20illustration%20two%20young%20people%20in%20a%20cozy%20cafe%20setting%2C%20warm%20lighting%2C%20emotional%20atmosphere%2C%20modern%20Seoul%20aesthetic%2C%20soft%20color%20palette%2C%20clean%20simple%20background%2C%20romantic%20webtoon%20cover%20style&width=800&height=600&seq=card-manga-04&orientation=landscape',
    title: '女神降临',
    tag: '韩漫',
    tagType: '韩漫',
    desc: '化妆变身后的丑小鸭逆袭成校园女神，甜蜜又真实的青春恋爱故事，治愈系韩漫代表作。',
    status: '已完结',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20slice%20of%20life%20comedy%20manga%20illustration%20a%20quirky%20family%20scene%20with%20a%20gentleman%20spy%20and%20a%20telepathic%20child%20in%20everyday%20setting%2C%20warm%20home%20atmosphere%2C%20fun%20and%20heartwarming%20tone%2C%20clean%20pastel%20colors&width=800&height=600&seq=card-manga-05&orientation=landscape',
    title: '间谍过家家',
    tag: '日漫',
    tagType: '日漫',
    desc: '间谍父亲、杀手母亲、超能力女儿组成临时家庭，爆笑又温馨的伪装日常。',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20action%20illustration%20with%20guardian%20spirits%20and%20ancient%20warriors%20in%20a%20mystical%20realm%2C%20epic%20scale%2C%20traditional%20Chinese%20elements%20with%20modern%20manhua%20aesthetic%2C%20dramatic%20composition%2C%20rich%20detail&width=800&height=600&seq=card-manga-06&orientation=landscape',
    title: '镇魂街',
    tag: '国漫',
    tagType: '国漫',
    desc: '人灵共存的神秘世界，镇魂将守护亡灵安宁。宏大世界观与热血打斗的完美结合。',
    status: '连载中',
  },
];

export default function CardsSection() {
  const tagStyle = (type: string) => {
    if (type === '韩漫') return 'bg-accent-100 text-accent-700';
    if (type === '日漫') return 'bg-primary-100 text-primary-700';
    return 'bg-secondary-100 text-secondary-700';
  };

  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">精选推荐</h2>
          <p className="text-foreground-500 text-sm mt-3">编辑团队为你精心挑选的优质漫画，每一部都值得一读</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CARDS.map((card) => (
            <div
              key={card.title}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className={`text-xs px-2 py-0.5 rounded-md font-medium ${tagStyle(card.tagType)}`}>
                    {card.tag}
                  </span>
                  <span className={`text-xs px-2 py-0.5 rounded-md font-medium ${
                    card.status === '已完结' ? 'bg-foreground-100 text-foreground-600' : 'bg-accent-500/90 text-background-50'
                  }`}>
                    {card.status}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}